export default "__VITE_ASSET__733a5dcc__"